export type EnvironmentConfig = {
	msalClientId: string;
	traxB2CClientId: string;
	trimbleMapsApiKey: string;
	environmentName?: string;
	b2cAuthority?: string;
	legacy?: string;
	services: {
		ltlQuoting: { url: string; scopes: string[] };
		ltlQuotingExternal: { url: string; scopes: string[] };
		traxArApi: { url: string; scopes: string[] };
	};
};

/** Global constant holding environment config values. */
export const environmentConfig = globalThis._envconfig;

declare global {
	var _envconfig: EnvironmentConfig;
}
